import React from 'react'
// components
import { Input } from 'components/FormElements'
import { BUTTON_LAYOUTS } from 'components/UI'
import ErrorMessage from 'components/UI/ErrorMessage'
// types
import { LinkData } from '../../types'
// views
import { Field, Footer, Form, SaveButton, StyledPopover } from './views'
// utils
import { isValidLink } from '../../utils'

export type PopoverAlign = 'left' | 'right'

interface Props {
  open: boolean
  anchorEl: HTMLElement | null
  align: PopoverAlign
  width: number
  onClose: () => void
  onSave: (data: LinkData) => void
}

const AddLinkPopover: React.FC<Props> = ({ open, anchorEl, align, width, onClose, onSave }) => {
  const [linkTarget, setLinkTarget] = React.useState('')
  const [linkName, setLinkName] = React.useState('')
  const [isTargetTouched, setTargetTouched] = React.useState(false)

  React.useEffect(() => {
    if (open) {
      setLinkTarget('')
      setLinkName('')
      setTargetTouched(false)
    }
  }, [open])

  const isValid = isValidLink(linkTarget)
  const isTargetError = isTargetTouched && !isValid

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    event.stopPropagation()

    if (!isValid) {
      return
    }

    onSave({ linkTarget, linkName: linkName.trim() })
    onClose()
  }

  return (
    <StyledPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: align }}
      transformOrigin={{ vertical: 'top', horizontal: align }}>
      <Form $width={width} onSubmit={handleSubmit} aria-label='Add link'>
        <Field>
          <Input
            autoFocus
            fullWidth
            name='linkTarget'
            label='Link target'
            value={linkTarget}
            isError={isTargetError}
            onChange={(event) => setLinkTarget(event.target.value)}
            handleOnBlur={() => setTargetTouched(true)}
          />
          {isTargetError && <ErrorMessage>Enter a valid link, e.g. https://example.com</ErrorMessage>}
        </Field>
        <Input
          fullWidth
          name='linkName'
          label='Link name (optional)'
          value={linkName}
          onChange={(event) => setLinkName(event.target.value)}
        />
        <Footer>
          <SaveButton type='submit' layout={BUTTON_LAYOUTS.PURPLE} shadowLess disabled={!isValid}>
            ADD
          </SaveButton>
        </Footer>
      </Form>
    </StyledPopover>
  )
}

export default AddLinkPopover
